import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import HardCopyPrintComponent from './PrintSubComponent/HardCopyPrintComponent';
import SoftCopyPrintComponent from './PrintSubComponent/SoftCopyPrintComponent';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getPrintAction, getPromisedPrintAction } from '../../Redux/Action/MemberAction';
import Auth from '../../Utilities/Auth';


function PrintComponent(props) {
    let agentDetail = JSON.parse(Auth.header().userdetail || "{}")

    console.log(agentDetail)



    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const promise_token = searchParams.get("promise_token")

    const [printDetails, setPrintDetails] = useState({});
    const [printDataAgent, setPrintDataAgent] = useState({});
    useEffect(() => {
        if (id) {
            const payload = {
                data: { collection_history_id: id },
                setPrintDetails,
                setPrintDataAgent
            };
            dispatch(getPrintAction(payload));
        } else if (promise_token) {
            const payload = {
                data: { promised_history_id: promise_token },
                setPrintDetails,
                setPrintDataAgent
            };
            dispatch(getPromisedPrintAction(payload));
        } else { }
    }, []);

    return (
        <>

            <Row>
                {agentDetail?.is_admin ? <><Col md={4} sm={12}>
                    <HardCopyPrintComponent printDetails={printDetails} printDataAgent={printDataAgent} />
                </Col></> : <></>}

                <Col md={8} sm={12}>
                    <SoftCopyPrintComponent printDetails={printDetails} printDataAgent={printDataAgent} />
                </Col>
            </Row>

        </>
    );
}

export default PrintComponent;